<template>
  <header id='header'>
    <div class='inner'>
      <div class='col col1'>
        <a class="backBtn">
          <span class='ico icoBack' :class="{invert: menu.originalImagePath !== ''}" @click.stop.prevent='backBtn'></span>
        </a>
      </div>
      <div class='col col2'>
        <h1>{{menuName}}</h1>
      </div>
      <div class='col col3'>
        <a class='btnNavi langNavi' v-if="this.globalType == 1 && this.isGlobalButtonEnabled()">
          <span
            @click="toggleLangBox()"
            class="ico lang"
            :class="{ ko: isKo, en: isEn, cn: isCn}"></span>
          <div class="langBox" style="display: none">
            <span class="ico lang ko" @click="setKorean()"></span>
            <span class="ico lang en" @click="setEnglish()"></span>
            <span class="ico lang ch" @click="setChinese()"></span>
          </div>
        </a>
        <a v-if="!this.appFlag" class='btnNavi sch'>
          <span @click.stop.prevent='moveToSearchPage' class='ico' :class="{invert: menu.originalImagePath !== ''}">검색</span>
        </a>
        <a v-if='this.appFlag' class='btnNavi home' @click="appMoveMain()">
            <span class='ico' :class="{invert: menu.originalImagePath !== ''}">홈</span>
        </a>
        <a v-if='this.appFlag' class='btnNavi all-menu' @click='allMenuToggleEmit'>
          <span class='ico' :class="{invert: menu.originalImagePath !== ''}">메뉴</span>
        </a>
      </div>
    </div>
  </header>
</template>
<script lang="js">
import $ from 'jquery'
import { THROW_SEARCH } from '@/router'
import { MENU_DETAIL_HEADER, MENU_DETAIL } from '@/utils/EndPoint'
import Vue from 'vue'
export default Vue.extend({
  name: MENU_DETAIL_HEADER,
  props: ['menuName', 'menu'],
  computed: {
    MultiLangStoreName () {
      return this.$store.state.MainPage.MultiLangStoreName
    },
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    },
    globalType () {
      return this.$store.state.MainIndex.globalType
    },
    groupQr () {
      return !!sessionStorage.getItem('GroupQrData')
    }
  },
  methods: {
    backBtn () {
      this.$router.push(
        {
          name: 'MAIN',
          query: {
            from: MENU_DETAIL
          }
        }
      )
    },
    moveToSearchPage () { THROW_SEARCH() },
    toggleLangBox () {
      $('#header .langNavi .langBox').fadeToggle(200)
    },
    setKorean () {
      this.$i18n.locale = 'ko'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setEnglish () {
      this.$i18n.locale = 'en'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    },
    setChinese () {
      this.$i18n.locale = 'cn'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = 'MODNPAY智慧点餐'
      this.$emit('reloadMainPage')
      this.toggleLangBox()
    }
  }
})
</script>
